/* unplugin-vue-components disabled */import script from "./UserInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserInfo.vue?vue&type=script&lang=ts&setup=true"

import "./UserInfo.vue?vue&type=style&index=0&id=546a1e13&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ZhongGuan\\Project\\zhong-guan-lh\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-546a1e13"]])

export default __exports__